export default {
      id: "ic_mode_light-usage",
      viewBox: "0 0 25 25",
      url: "../dist/images/" + "sprite.svg#ic_mode_light-usage",
      toString: function () {
        return this.url;
      }
    }